/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { ShopRealtimeInfo } from "../../../../components/index";
import { useMenu } from "@app/vue/providers/Menu";
import { useLocalization } from "@lemmonhq/uikit";

export const RealtimeButton = defineComponent({
  name: "RealtimeButton",
  setup(props) {
    const { realtime, groupOrder } = useMenu();
    const {} = useMenu();
    const showingRealtimeInfoModal = ref(false);
    const { t } = useLocalization();
    return () => {
      return (
        <>
          <button
            onClick={() => {
              showingRealtimeInfoModal.value = true;
            }}
            class={[
              "btn btn-ghost text-sm flex items-center gap-1 px-3 hover:bg-base-300/70 !rounded-full",
              realtime.enabled.value ? "text-secondary" : "text-base-content",
            ]}
          >
            <span class="material-symbols-outlined text-xl">
              {realtime.enabled.value ? "diversity_3" : "group_add"}
            </span>
            {realtime.isConnecting.value ? (
              <div class="loading loading-spinner loading-xs"></div>
            ) : null}
            {realtime.enabled.value && !realtime.isConnecting.value ? (
              <span> {realtime.groupState.value.members.length || 1}</span>
            ) : null}
            {realtime.isConnecting.value ? null : realtime.enabled.value ? (
              <span class="hidden lg:inline">
                {" "}
                {t("customer.shop_shell.people")}
              </span>
            ) : (
              <span class="hidden lg:inline">
                {t("customer.group_order.order_together")}
              </span>
            )}
          </button>
          {showingRealtimeInfoModal.value ? (
            <ShopRealtimeInfo
              onClose={() => (showingRealtimeInfoModal.value = false)}
            />
          ) : null}
        </>
      );
    };
  },
});
